import { IMonitoringPointResponse } from '@kcftech/prometheus-client';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceQuery,
} from 'custom_hooks/data_hooks/data_source/data_source';
import {
    InfiniteDataSource,
    useInfiniteDataSource,
} from 'custom_hooks/data_hooks/data_source/useInfiniteDataSource';
import { buildOrderBy, Filter, toDataSourceResult } from 'utils/query_v3';

export type MonitoringPointFilter = Readonly<{
    corporationId?: string;
    locationId?: string;
    parentId?: string;
    nameSearch?: string;
}>;

export type MonitoringPointDataSourceOptions = BaseDataSourceOptions<
    IMonitoringPointResponse,
    MonitoringPointFilter
>;

const queryFn: DataSourceQuery<IMonitoringPointResponse, MonitoringPointFilter> = ({
    filter: { corporationId, locationId, parentId, nameSearch },
    sort,
    page,
    pageLimit,
}) => {
    const filter = Filter.and(
        corporationId ? Filter.eq('CorporationId', corporationId) : undefined,
        locationId ? Filter.eq('LocationId', locationId) : undefined,
        parentId ? Filter.eq('ParentId', parentId) : undefined,
        nameSearch
            ? Filter.or(
                  Filter.contains('Name', nameSearch),
                  Filter.contains('Abbreviation', nameSearch),
              )
            : undefined,
    );

    const orderBy = buildOrderBy(sort);

    return toDataSourceResult(
        sdClient.getMonitoringPoints({ filter, page, pageLimit, orderBy }),
    );
};

export type MonitoringPointOverviewInfiniteDataSource = InfiniteDataSource<
    IMonitoringPointResponse,
    MonitoringPointFilter
>;

export function useMonitoringPointOverviewInfiniteDataSource(
    options: MonitoringPointDataSourceOptions,
): MonitoringPointOverviewInfiniteDataSource {
    return useInfiniteDataSource({
        ...options,
        query: queryFn,
    });
}
